<template lang="pug">
  #home-wrapper
    top-bar
    sidebar-menu
    client-modal(:auto-open='true')
    my-account-modal
    change-application-modal
    router-view
</template>

<script>
import TopBar from '../../layout/menu/TopBar'
import SidebarMenu from '../../layout/menu/SidebarMenu'
import ClientModal from '../../modals/clientModal/ClientModal'
import MyAccountModal from '../../modals/myAccountModal/MyAccountModal'
import ChangeApplicationModal from '../../modals/changeApplicationModal/ChangeApplicationModal'

export default {
  name: 'Home',

  components: {
    TopBar,
    SidebarMenu,
    ClientModal,
    MyAccountModal,
    ChangeApplicationModal
  }
}
</script>

<style>
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

input[type=number] {
  -moz-appearance:textfield !important;
}

a {
  cursor: pointer
}

.table-thead-cursor-pointer{
  cursor: pointer;
}

.table-thead-cursor-pointer tbody tr span {
  cursor: pointer;
}

.modal .modal-header {
  text-align: center;
  border-bottom: 0;
  padding: 10px 25px 10px 25px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?7ef0e930